import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
import { Sanitizer } from "../util/sanitizer";
import { logger as coreLogger } from "../log";
/**
 * Creates a policy that logs information about the outgoing request and the incoming responses.
 * @param loggingOptions - Logging options.
 * @returns An instance of the {@link LogPolicy}
 */

export function logPolicy() {
  var loggingOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    create: function create(nextPolicy, options) {
      return new LogPolicy(nextPolicy, options, loggingOptions);
    }
  };
}
/**
 * A policy that logs information about the outgoing request and the incoming responses.
 */

export var LogPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(LogPolicy, _BaseRequestPolicy);

  var _super = _createSuper(LogPolicy);

  function LogPolicy(nextPolicy, options) {
    var _this;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$logger = _ref.logger,
        logger = _ref$logger === void 0 ? coreLogger.info : _ref$logger,
        _ref$allowedHeaderNam = _ref.allowedHeaderNames,
        allowedHeaderNames = _ref$allowedHeaderNam === void 0 ? [] : _ref$allowedHeaderNam,
        _ref$allowedQueryPara = _ref.allowedQueryParameters,
        allowedQueryParameters = _ref$allowedQueryPara === void 0 ? [] : _ref$allowedQueryPara;

    _classCallCheck(this, LogPolicy);

    _this = _super.call(this, nextPolicy, options);
    _this.logger = logger;
    _this.sanitizer = new Sanitizer({
      allowedHeaderNames: allowedHeaderNames,
      allowedQueryParameters: allowedQueryParameters
    });
    return _this;
  }
  /**
   * Header names whose values will be logged when logging is enabled. Defaults to
   * Date, traceparent, x-ms-client-request-id, and x-ms-request id.  Any headers
   * specified in this field will be added to that list.  Any other values will
   * be written to logs as "REDACTED".
   * @deprecated Pass these into the constructor instead.
   */


  _createClass(LogPolicy, [{
    key: "allowedHeaderNames",
    get: function get() {
      return this.sanitizer.allowedHeaderNames;
    }
    /**
     * Header names whose values will be logged when logging is enabled. Defaults to
     * Date, traceparent, x-ms-client-request-id, and x-ms-request id.  Any headers
     * specified in this field will be added to that list.  Any other values will
     * be written to logs as "REDACTED".
     * @deprecated Pass these into the constructor instead.
     */
    ,
    set: function set(allowedHeaderNames) {
      this.sanitizer.allowedHeaderNames = allowedHeaderNames;
    }
    /**
     * Query string names whose values will be logged when logging is enabled. By default no
     * query string values are logged.
     * @deprecated Pass these into the constructor instead.
     */

  }, {
    key: "allowedQueryParameters",
    get: function get() {
      return this.sanitizer.allowedQueryParameters;
    }
    /**
     * Query string names whose values will be logged when logging is enabled. By default no
     * query string values are logged.
     * @deprecated Pass these into the constructor instead.
     */
    ,
    set: function set(allowedQueryParameters) {
      this.sanitizer.allowedQueryParameters = allowedQueryParameters;
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(request) {
      var _this2 = this;

      if (!this.logger.enabled) return this._nextPolicy.sendRequest(request);
      this.logRequest(request);
      return this._nextPolicy.sendRequest(request).then(function (response) {
        return _this2.logResponse(response);
      });
    }
  }, {
    key: "logRequest",
    value: function logRequest(request) {
      this.logger("Request: ".concat(this.sanitizer.sanitize(request)));
    }
  }, {
    key: "logResponse",
    value: function logResponse(response) {
      this.logger("Response status code: ".concat(response.status));
      this.logger("Headers: ".concat(this.sanitizer.sanitize(response.headers)));
      return response;
    }
  }]);

  return LogPolicy;
}(BaseRequestPolicy);